import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// Polls a GPT job until done (no Cloudflare 100s limit). Max ~10 min.
export async function pollChatJob(owner, jobId) {
  for (let i = 0; i < 200; i++) {
    await sleep(3000);
    let j;
    try {
      j = (await axios.get(`${API}/api/brief-chat/${owner}/job/${jobId}`)).data;
    } catch (e) {
      continue;
    }
    if (j.status === "done") return j;
    if (j.status === "error") throw new Error(j.error || "GPT a échoué");
  }
  throw new Error("GPT n'a pas répondu après 10 min");
}
